module.exports = __webpack_public_path__ + "img/dubrovny.42e74fc3.png";